<template>
  <div>
    <!-- <div class="div-black"></div> -->
    <div class="div-bg">
      <img class="header-img" src="@/assets/images/solution-header-bg.png" />
      <h1 class="text-center h1">
        <img
          class="header-img"
          src="@/assets/images/icon/icon_companyLogo.png"
        />
      </h1>

      <!-- <h4 class="text-center h4">益狐智造科技（武汉）有限公司</h4> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyHeader"
};
</script>

<style lang="stylus" scoped>
.div-black {
  background: #1B1B1B;
  width: 100%;
  height: 19rem;
}

.div-bg {
  position: relative;
  // margin-top: -10rem;
  width: 100%;
  // left: 5%;
  margin-bottom: 5rem;

  .header-img {
    width: 100%;
  }

  .h1 {
    position: absolute;
    font-size: 3.1rem;
    color: #ffffff;
    top: 10rem;
    left: 50%;
    transform: translateX(-50%);
  }

  .h4 {
    position: absolute;
    color: #ffffff;
    top: 19rem;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/company/components/ContentHeader.vue